export default __webpack_public_path__ + "static/media/service8.4a2c3e8d.png";